import { Component, ChangeDetectionStrategy , inject} from '@angular/core';
import { Router } from '@angular/router';

//Componentes
import { CrearEstacionesComponent } from '@/app/components/catalogos/Estaciones/crear-estaciones/crear-estaciones.component';
import { EditarEstacionesComponent } from '@/app/components/catalogos/Estaciones/editar-estaciones/editar-estaciones.component';

//Servicios
import { EstacionesService } from '@/app/services/estaciones.service';

//Librerías externas
import {MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

//Modelos
import { Estaciones } from '@/app/models/Estaciones';

@Component({
    selector: 'app-lista-estaciones',
    templateUrl: './lista-estaciones.component.html',
    styleUrls: ['./lista-estaciones.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ListaEstacionesComponent {
  private spinner = inject(NgxSpinnerService);

  //Lista de usuarios
  listaEstaciones: Estaciones[] = [];

  constructor(
    private estacionesService: EstacionesService,
    private toastr: ToastrService,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.obtenerEstaciones();
  }

  obtenerEstaciones() {
    this.spinner.show();

    this.estacionesService.obtenerEstaciones().subscribe({
      next: (data: any) => {
        this.listaEstaciones = data.Estaciones;
        this.spinner.hide();
      },
      error: (err) => {
        this.spinner.hide();

        if (err.status == 401) {
          this.toastr.error(
            'Tu sesión expiró o no tienes permiso para ver esta página.',
            'Acceso no autorizado'
          );
          this.router.navigate(['/login']);
        } else {
          if (err.error) {
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo.Error, 'Error');
          }
        }
        console.log(err);
      },
    });
  }

  abrirModalCrearEstaciones() {
    const dialogRef = this.dialog.open(CrearEstacionesComponent, {
      width: '800px',
      height: '530px',
      panelClass: 'custom-dialog-container',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.updateList) this.obtenerEstaciones();
    });

    this.router.events.subscribe(() => {
      dialogRef.close();
    });
  }

  abrirModalEditarEstaciones(estacion: Estaciones) {
    const dialogRef = this.dialog.open(EditarEstacionesComponent, {
      width: '800px',
      height: '530px',
      panelClass: 'custom-dialog-container',
      data: estacion,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.updateList) this.obtenerEstaciones();
    });

    this.router.events.subscribe(() => {
      dialogRef.close();
    });
  }
}
